import _map from 'lodash/map';
import _split from 'lodash/split';
import _head from 'lodash/head';
import _includes from 'lodash/includes';
import APPCONFIG from '../../constants/Config';
import { WS_TOPIC_DEVICE_SMS } from '../../constants/App';
import * as wsEvents from '../../constants/WsEvents';
import {
  REINIT_STATE,
  GET_DEVICE_SMS_HISTORY,
  GET_DEVICE_SMS_HISTORY_SUCCESS,
  GET_DEVICE_SMS_HISTORY_ERROR,
  GET_DEVICE_SMS_STATUS,
  GET_DEVICE_SMS_STATUS_SUCCESS,
  GET_DEVICE_SMS_STATUS_ERROR,
  WS_RECEIVED_OPERATION,
} from '../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserializeSms } from '../../models/device';
/* eslint-enable import/named */

const managedTopics = [WS_TOPIC_DEVICE_SMS];

const initialSettings = APPCONFIG.deviceSms;
const deviceSms = (state = initialSettings, action) => {
  let wsPayload;
  let wsTopic;
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      if (action.target === 'deviceSms') {
        return {
          ...initialSettings,
        };
      }
      return state;
    // HISTORY
    case GET_DEVICE_SMS_HISTORY:
      return {
        ...state,
        list: {
          ...state.list,
          error: null,
          loading: true,
          elements: null,
        },
      };
    case GET_DEVICE_SMS_HISTORY_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          error: action.error,
          loading: false,
        },
      };
    case GET_DEVICE_SMS_HISTORY_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          elements: deserializeSms(action.data.data),
          loading: false,
        },
      };
    // STATUS
    case GET_DEVICE_SMS_STATUS:
      return {
        ...state,
        getStatus: {
          ...state.getStatus,
          error: null,
          done: false,
        },
      };
    case GET_DEVICE_SMS_STATUS_ERROR:
      return {
        ...state,
        getStatus: {
          ...state.getStatus,
          error: action.error,
        },
      };
    case GET_DEVICE_SMS_STATUS_SUCCESS:
      return {
        ...state,
        getStatus: {
          ...state.getStatus,
          error: null,
          done: true,
        },
        list: {
          ...state.list,
          elements: _map(state.list.elements, (sms) => (sms.id === action.data.data.id
            ? {
              ...sms,
              ...action.data.data,
            } : sms
          )),
        },
      };
    /**
    * Websocket operations catching
    */
    case WS_RECEIVED_OPERATION:
      wsPayload = action.payload;
      wsTopic = _head(_split(action.topic, ':'));
      if (wsPayload && wsTopic && _includes(managedTopics, wsTopic)) {
        if (action.operation === wsEvents.EVENT_INFO) {
          return {
            ...state,
            list: {
              ...state.list,
              elements: _map(state.list.elements, (sms) => (sms.id === wsPayload.id
                ? {
                  ...sms,
                  ...wsPayload.data,
                } : sms
              )),
            },
          };
        }
      }
      return state;
    default:
      return state;
  }
};

export default deviceSms;



// WEBPACK FOOTER //
// ./reducers/device/deviceSms.js